import {useEffect} from 'react';
import 'firebase/auth';

import {auth} from "../firebaseConfig";
import {addBreadcrumb, clearAuth, setToken} from "../utils/auth";
import {multiFactor} from "firebase/auth";
import {parseJwtToken} from "../utils/token";
import {useAuthStore} from "../store/authStore";
import {useAppStore} from "../store/appStore";

export const useFirebaseTokenListener = () => {
    const isIntegration = useAppStore((state) => state.isIntegration);

    useEffect(() => {
        const unsubscribe = auth.onIdTokenChanged(async (user) => {
            //This includes sign-in, sign-out, and token refresh events.
            if (!user) return;

            try {
                const idToken = await user.getIdToken();

                if (idToken === useAuthStore.getState().idToken) return;

                const has2FA = multiFactor(user).enrolledFactors.length > 0
                const payload = parseJwtToken(idToken);
                const isGoogleAuth = payload?.firebase?.sign_in_provider === 'google.com'
                addBreadcrumb('Token changed', {has2FA, isGoogleAuth, payload})
                console.info("Has 2FA:", has2FA);
                console.info("Is Google Auth", isGoogleAuth);

                if (!has2FA && !isGoogleAuth) return

                console.info("Id token changed");
                setToken(idToken, payload);
            } catch (error) {
                console.error("Error handling token change:", error);
                clearAuth()
            }
        });

        return () => {
            if (!isIntegration) unsubscribe();
        };
    }, [isIntegration]);
};
